import { render, staticRenderFns } from "./WorkflowManagement.vue?vue&type=template&id=1d47d7bc&scoped=true"
import script from "./WorkflowManagement.vue?vue&type=script&lang=js"
export * from "./WorkflowManagement.vue?vue&type=script&lang=js"
import style0 from "./WorkflowManagement.vue?vue&type=style&index=0&id=1d47d7bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d47d7bc",
  null
  
)

export default component.exports